export const dict = {
  en: {
    // Common
    app_name: "Lumfi Cash Pilot",
    continue: "Continue",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    skip: "Skip",
    loading: "Loading...",
    // Landing
    landing_badge: "Pilot Access",
    landing_title: "Know how much money you can use this week without running out of cash.",
    landing_sub: "For freelancers with variable income, pending clients, and upcoming payments.",
    start_diagnosis: "Start cash diagnosis",
    sign_in: "Sign in",
    sign_up: "Create account",
    // Landing — extended sections
    landing_eyebrow: "For freelancers in LATAM",
    landing_hero_title_a: "How much can I spend this month",
    landing_hero_title_b: "without breaking it?",
    landing_hero_sub: "Lumfi is the cash-flow pilot for variable income. One number tells you what's safe to use today — backed by your receivables, debts, and upcoming bills.",
    landing_hero_cta: "Get my safe-to-use number",
    landing_hero_secondary: "See how it works",
    landing_hero_chip_1: "No credit card",
    landing_hero_chip_2: "Free plan forever",
    landing_hero_chip_3: "Setup in 4 minutes",
    landing_snap_label: "Your real cash today",
    landing_snap_safe: "Safe to use this week",
    landing_snap_pending: "Pending payments",
    landing_snap_risk: "Month risk · Medium",
    landing_snap_explain: "Includes 2 client payments due + 10% safety reserve.",
    landing_trust_label: "Built for variable income across LATAM",
    landing_problem_eyebrow: "The freelancer anxiety",
    landing_problem_h2: "You don't have a salary. You have a question every Monday.",
    landing_problem_q1: "Can I pay rent and still buy the equipment I need this month?",
    landing_problem_q2: "Is the money in my account already promised to taxes, or is it mine?",
    landing_problem_q3: "If the client pays late again, am I in trouble?",
    landing_problem_h2b: "Lumfi answers all three. Every day.",
    landing_problem_p: "Other tools track what already happened. Lumfi pilots what's coming next — so you stop guessing and start moving with confidence.",
    landing_steps_eyebrow: "How it works",
    landing_steps_h2: "Four minutes to your first cash diagnosis",
    landing_step_1_t: "Tell us what's real",
    landing_step_1_d: "Cash you have, clients who owe you, bills coming, debts in flight. No bank linking, no spreadsheet imports.",
    landing_step_2_t: "We do the math",
    landing_step_2_d: "Receivables × probability − fixed payments − reserve = your safe-to-use number. Updated live.",
    landing_step_3_t: "Coast with a copilot",
    landing_step_3_d: "Log moves by chat (web, Telegram, WhatsApp). The pilot recalculates and tells you if the trajectory changes.",
    landing_features_eyebrow: "What you get",
    landing_features_h2: "Everything a CFO would build for you. Without the CFO.",
    landing_feat_cash_t: "Real cash, today",
    landing_feat_cash_d: "Not your bank balance. The cash that's actually yours after debts, taxes and commitments.",
    landing_feat_risk_t: "Month risk stoplight",
    landing_feat_risk_d: "Green / Amber / Red. So a glance tells you if next month will be tight.",
    landing_feat_ai_t: "AI chat to log moves",
    landing_feat_ai_d: "\"Pagué Netflix 39 pesos\" and the pilot updates everything. Works on Telegram, WhatsApp and web.",
    landing_feat_rec_t: "Receivables & payments",
    landing_feat_rec_d: "Who owes you, who you owe. Recurring or one-shot, in any currency.",
    landing_feat_wealth_t: "Wealth modules",
    landing_feat_wealth_d: "Investments, debts and savings goals — all weighted into your safe-to-use number.",
    landing_feat_fx_t: "Multi-currency, native",
    landing_feat_fx_d: "ARS, BRL, CLP, COP, MXN, PEN, UYU. FX rates auto-applied to give you one honest number.",
    landing_bots_eyebrow: "Pilot your money from anywhere",
    landing_bots_h2: "Telegram. WhatsApp. Web. Your call.",
    landing_bots_p: "Three seconds to log an expense. Two to ask \"can I afford this?\". Lumfi answers in the channel you already live in.",
    landing_pricing_eyebrow: "Pricing",
    landing_pricing_h2: "Your balance isn't your spendable cash. Lumfi tells you how much you can use without breaking the month.",
    landing_pricing_free_t: "Control",
    landing_pricing_free_d: "Real cash + risk badge + receivables. Forever free.",
    landing_pricing_pilot_t: "Pilot",
    landing_pricing_pilot_d: "Adds the AI copilot on chat, advanced forecasting and recurring rollovers.",
    landing_pricing_negocio_t: "Negocio",
    landing_pricing_negocio_d: "Teams, custom currencies, priority support and white-label exports.",
    landing_pricing_cta: "See full pricing",
    landing_pricing_popular: "Most chosen",
    landing_faq_eyebrow: "FAQ",
    landing_faq_h2: "Questions freelancers actually ask",
    landing_faq_q1: "Do I need to link my bank?",
    landing_faq_a1: "No. Lumfi works with what you tell it. You keep full control over what's tracked and what isn't.",
    landing_faq_q2: "I bill in USD but live in ARS. Will this work?",
    landing_faq_a2: "Yes. Lumfi is multi-currency at every level: per movement, per receivable, per debt. We apply daily FX so your safe-to-use number is one honest figure in your home currency.",
    landing_faq_q3: "Is my data private?",
    landing_faq_a3: "Your numbers never leave your account. We don't sell or share financial data, and you can wipe everything with one click.",
    landing_faq_q4: "What if a client pays late?",
    landing_faq_a4: "The risk stoplight reacts instantly. You'll see the new month color and Lumfi will suggest where to cut to keep coasting.",
    landing_faq_q5: "Can I use Lumfi with partners or a team?",
    landing_faq_a5: "The Negocio plan supports shared workspaces, role-based access and audit logs.",
    landing_final_eyebrow: "Stop guessing",
    landing_final_h2: "Find your real number in 4 minutes.",
    landing_final_p: "Free forever for the essentials. No card. No commitment. Just clarity.",
    landing_final_cta: "Get started — it's free",
    landing_footer_tag: "The cash-flow pilot for freelancers.",
    landing_footer_product: "Product",
    landing_footer_company: "Company",
    landing_footer_legal: "Legal",
    landing_footer_pricing: "Pricing",
    landing_footer_features: "Features",
    landing_footer_about: "About",
    landing_footer_privacy: "Privacy",
    landing_footer_terms: "Terms",
    landing_footer_rights: "All rights reserved",
    // Auth
    email: "Email",
    password: "Password",
    login_title: "Welcome back",
    register_title: "Create your Lumfi account",
    no_account: "No account yet?",
    have_account: "Already have an account?",
    // Onboarding
    step_of: "Step {n} of 6",
    profile_setup: "Profile Setup",
    onb_welcome_title: "Welcome to Lumfi",
    onb_welcome_sub: "Let's set up your profile to tailor your cash diagnosis.",
    full_name: "Full name",
    professional_activity: "Professional activity",
    currency: "Currency",
    avg_monthly_income: "Average monthly income",
    money_title: "Where is your money today?",
    money_sub: "Add your cash, bank and digital wallet balances.",
    receivables_title: "Pending receivables",
    receivables_sub: "What clients owe you and when.",
    payments_title: "Upcoming payments",
    payments_sub: "Bills and obligations coming up.",
    withdrawal_title: "Desired withdrawal",
    withdrawal_sub: "How much do you want to use this week?",
    desired_amount: "Desired amount",
    reason: "Reason",
    finish_calc: "Calculate dashboard",
    // Dashboard
    dashboard: "Dashboard",
    real_cash: "Real available cash",
    safe_to_use: "Safe to use this week",
    monthly_risk: "Monthly Risk",
    recommended_action: "Recommended Action",
    current_cash: "Current cash",
    expected_receivables: "Expected receivables",
    upcoming_payments: "Upcoming payments",
    suggested_reserve: "Suggested reserve",
    desired_withdrawal: "Desired withdrawal",
    last_updated: "Last updated",
    of_real_cash: "of real available cash",
    financial_breakdown: "Financial Breakdown",
    // Timeframe clarity (Dashboard / History / Report)
    dashboard_scope_badge: "Current snapshot",
    dashboard_scope_sub: "Live view — reflects your balance, receivables and payments right now.",
    history_scope_badge: "Past activity",
    history_scope_sub: "Only movements, receivables and payments that already happened in the selected month.",
    report_scope_badge_weekly: "Selected week",
    report_scope_badge_monthly: "Selected month",
    report_scope_sub: "Snapshot for the period below, including pending items due inside it.",
    report_subtitle: "Period summary",
    showing_period: "Showing",
    // FX drift
    fx_drift_title: "FX drift in this period",
    fx_drift_sub: "Value gained or lost on foreign-currency items purely due to exchange-rate movement since they were recorded.",
    fx_drift_assets: "Receivables drift",
    fx_drift_liabilities: "Payments drift",
    fx_drift_realized: "Realized drift",
    fx_drift_net: "Net FX impact",
    fx_drift_recorded: "Recorded value",
    fx_drift_current: "Current value",
    fx_drift_empty: "No foreign-currency items in this period — nothing to compare against today's rate.",
    fx_drift_pending_receivables: "Pending receivables",
    fx_drift_pending_payments: "Pending payments",
    fx_drift_realized_section: "Already settled",
    fx_drift_favourable: "Favourable",
    fx_drift_unfavourable: "Unfavourable",
    fx_drift_neutral: "Neutral",
    fx_resnapshot_btn: "Reset FX baseline to today",
    fx_resnapshot_sub: "Re-records every foreign-currency entry against today's exchange rate. Drift starts again from zero.",
    fx_resnapshot_done: "Re-snapshotted",
    fx_resnapshot_confirm: "This rewrites the amount and fx_rate on every receivable, payment and movement you have in a non-profile currency. The drift calculation will reset. Continue?",
    // Nav
    home: "Home",
    nav_add: "Assistant",
    nav_receivables: "Receivables",
    nav_payments: "Payments",
    nav_history: "Movements",
    nav_report: "Report",
    logout: "Log out",
    load_demo: "Load demo data",
    clear_demo: "Clear my data",
    // Quick add
    quick_movement: "Quick Movement",
    quick_movement_help: "Use +/- and type naturally to log a transaction.",
    quick_placeholder: "+ 800000 Client Ana paid design\n- 120000 internet bill",
    categorize_as: "Categorize as",
    income: "Income",
    expense: "Expense",
    receivable: "Receivable",
    payment: "Payment",
    save_movement: "Save Movement",
    amount: "Amount",
    description: "Description",
    // Receivables
    new_receivable: "New receivable",
    client_name: "Client name",
    expected_date: "Expected date",
    probability: "Probability",
    high: "High",
    medium: "Medium",
    low: "Low",
    pending: "Pending",
    collected: "Collected",
    mark_collected: "Mark collected",
    // Payments
    new_payment: "New payment",
    concept: "Concept",
    due_date: "Due date",
    type: "Type",
    priority: "Priority",
    paid: "Paid",
    mark_paid: "Mark paid",
    postpone: "Postpone",
    // Report
    weekly_report: "Weekly Report",
    copy_summary: "Copy summary",
    pdf_downloaded: "PDF downloaded",
    print: "Print / PDF",
    copied: "Copied to clipboard",
    // Risk labels
    risk_low: "Low",
    risk_medium: "Medium",
    risk_high: "High",
    confirm_delete: "Confirm delete",
    confirm_delete_recv: "Delete receivable from {name}? This cannot be undone.",
    confirm_delete_pay: "Delete payment {name}? This cannot be undone.",
    confirm_clear_data: "Clear all your data? This will remove all cash accounts, receivables, payments and movements.",
    language: "Language",
    action_do_not_withdraw: "Do not withdraw more than {safe_amount} this week.",
    action_collect_largest: "Collect from {client_name} before making new payments.",
    action_prioritize_payments: "Prioritize upcoming payments before discretionary spending.",
    action_safe_use: "You can safely use up to {safe_amount} this week.",
    action_stay_cautious: "Stay cautious. Safe to use this week: {safe_amount}.",
    wealth_overview: "Wealth overview",
    net_worth: "Net worth",
    investments: "Investments",
    debts: "Debts",
    goals: "Goals",
    items: "items",
    recurring: "Recurring",
    frequency: "Frequency",
    end_date: "End date",
    weekly: "Weekly",
    biweekly: "Biweekly",
    monthly: "Monthly",
    quarterly: "Quarterly",
    yearly: "Yearly",
  },
  es: {
    app_name: "Lumfi Cash Pilot",
    continue: "Continuar",
    back: "Atrás",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    edit: "Editar",
    add: "Agregar",
    skip: "Omitir",
    loading: "Cargando...",
    landing_badge: "Acceso Piloto",
    landing_title: "Sabe cuánto dinero puede usar esta semana sin quedarse sin caja.",
    landing_sub: "Para freelancers con ingresos variables, cobros pendientes y pagos próximos.",
    start_diagnosis: "Iniciar diagnóstico",
    sign_in: "Iniciar sesión",
    sign_up: "Crear cuenta",
    landing_eyebrow: "Para freelancers en LATAM",
    landing_hero_title_a: "¿Cuánto puedo gastar este mes",
    landing_hero_title_b: "sin reventarlo?",
    landing_hero_sub: "Lumfi es el piloto de flujo de caja para ingresos variables. Un número te dice qué es seguro usar hoy — basado en tus cobros, deudas y pagos próximos.",
    landing_hero_cta: "Quiero mi número seguro",
    landing_hero_secondary: "Ver cómo funciona",
    landing_hero_chip_1: "Sin tarjeta",
    landing_hero_chip_2: "Plan gratis para siempre",
    landing_hero_chip_3: "Listo en 4 minutos",
    landing_snap_label: "Tu efectivo real hoy",
    landing_snap_safe: "Seguro para usar esta semana",
    landing_snap_pending: "Cobros pendientes",
    landing_snap_risk: "Riesgo del mes · Medio",
    landing_snap_explain: "Incluye 2 cobros de clientes y 10% de reserva.",
    landing_trust_label: "Pensado para ingresos variables en toda LATAM",
    landing_problem_eyebrow: "La ansiedad del freelancer",
    landing_problem_h2: "No tienes sueldo. Tienes una pregunta cada lunes.",
    landing_problem_q1: "¿Puedo pagar el alquiler y comprar el equipo que necesito este mes?",
    landing_problem_q2: "¿Esta plata ya está prometida a impuestos, o realmente es mía?",
    landing_problem_q3: "Si el cliente vuelve a pagar tarde, ¿estoy en problemas?",
    landing_problem_h2b: "Lumfi responde las tres. Todos los días.",
    landing_problem_p: "Otras herramientas registran lo que ya pasó. Lumfi pilotea lo que viene — para que dejes de adivinar y te muevas con confianza.",
    landing_steps_eyebrow: "Cómo funciona",
    landing_steps_h2: "Cuatro minutos hasta tu primer diagnóstico de caja",
    landing_step_1_t: "Cuentanos lo real",
    landing_step_1_d: "El efectivo que tienes, los clientes que te deben, las facturas que vienen, las deudas en curso. Sin conectar el banco, sin importar planillas.",
    landing_step_2_t: "Hacemos las cuentas",
    landing_step_2_d: "Cobros × probabilidad − pagos fijos − reserva = tu número seguro. Se actualiza en vivo.",
    landing_step_3_t: "Vuela con copiloto",
    landing_step_3_d: "Registra movimientos por chat (web, Telegram, WhatsApp). El piloto recalcula y te avisa si la trayectoria cambia.",
    landing_features_eyebrow: "Qué obtienes",
    landing_features_h2: "Todo lo que un CFO armaría para ti. Sin el CFO.",
    landing_feat_cash_t: "Efectivo real, hoy",
    landing_feat_cash_d: "No es el saldo del banco. Es la plata que realmente es tuya después de deudas, impuestos y compromisos.",
    landing_feat_risk_t: "Semáforo de riesgo mensual",
    landing_feat_risk_d: "Verde / Amarillo / Rojo. Un vistazo te dice si el mes que viene va a estar ajustado.",
    landing_feat_ai_t: "Chat con IA para registrar",
    landing_feat_ai_d: "\"Pagué Netflix 39 pesos\" y el piloto actualiza todo. Funciona en Telegram, WhatsApp y web.",
    landing_feat_rec_t: "Cobros y pagos",
    landing_feat_rec_d: "Quién te debe, a quién le debes. Recurrentes o únicos, en cualquier moneda.",
    landing_feat_wealth_t: "Módulos patrimoniales",
    landing_feat_wealth_d: "Inversiones, deudas y metas de ahorro — todos ponderados en tu número seguro.",
    landing_feat_fx_t: "Multi-moneda nativo",
    landing_feat_fx_d: "ARS, BRL, CLP, COP, MXN, PEN, UYU. Cotizaciones aplicadas para darte un número honesto.",
    landing_bots_eyebrow: "Pilotea tu plata desde donde estés",
    landing_bots_h2: "Telegram. WhatsApp. Web. Tu eliges.",
    landing_bots_p: "Tres segundos para registrar un gasto. Dos para preguntar \"¿puedo darme este lujo?\". Lumfi te responde en el canal donde ya vives.",
    landing_pricing_eyebrow: "Precios",
    landing_pricing_h2: "Tu saldo no es tu plata disponible. Lumfi te dice cuánto puedes usar sin romper el mes.",
    landing_pricing_free_t: "Control",
    landing_pricing_free_d: "Efectivo real + semáforo + cobros. Gratis para siempre.",
    landing_pricing_pilot_t: "Pilot",
    landing_pricing_pilot_d: "Suma el copiloto IA en chat, pronósticos avanzados y rollovers recurrentes.",
    landing_pricing_negocio_t: "Negocio",
    landing_pricing_negocio_d: "Equipos, monedas custom, soporte prioritario y exportes white-label.",
    landing_pricing_cta: "Ver precios completos",
    landing_pricing_popular: "El más elegido",
    landing_faq_eyebrow: "FAQ",
    landing_faq_h2: "Preguntas que los freelancers realmente hacen",
    landing_faq_q1: "¿Tengo que conectar el banco?",
    landing_faq_a1: "No. Lumfi trabaja con lo que tu le cuentas. Tienes control total de qué se registra y qué no.",
    landing_faq_q2: "Facturo en USD pero vivo en ARS. ¿Va a funcionar?",
    landing_faq_a2: "Sí. Lumfi es multi-moneda a todo nivel: por movimiento, por cobro, por deuda. Aplicamos cotizaciones diarias para que tu número seguro sea una sola cifra honesta en tu moneda.",
    landing_faq_q3: "¿Mis datos son privados?",
    landing_faq_a3: "Tus números no salen de tu cuenta. No vendemos ni compartimos datos financieros, y puedes borrar todo con un click.",
    landing_faq_q4: "¿Y si un cliente paga tarde?",
    landing_faq_a4: "El semáforo reacciona al instante. Vas a ver el nuevo color del mes y Lumfi te sugiere dónde recortar para seguir volando.",
    landing_faq_q5: "¿Puedo usar Lumfi con socios o equipo?",
    landing_faq_a5: "El plan Negocio soporta workspaces compartidos, roles por usuario y auditoría.",
    landing_final_eyebrow: "Deja de adivinar",
    landing_final_h2: "Encuentra tu número real en 4 minutos.",
    landing_final_p: "Gratis para siempre lo esencial. Sin tarjeta. Sin compromiso. Solo claridad.",
    landing_final_cta: "Empezar — es gratis",
    landing_footer_tag: "El piloto de flujo de caja para freelancers.",
    landing_footer_product: "Producto",
    landing_footer_company: "Empresa",
    landing_footer_legal: "Legal",
    landing_footer_pricing: "Precios",
    landing_footer_features: "Funcionalidades",
    landing_footer_about: "Sobre Lumfi",
    landing_footer_privacy: "Privacidad",
    landing_footer_terms: "Términos",
    landing_footer_rights: "Todos los derechos reservados",
    email: "Correo electrónico",
    password: "Contraseña",
    login_title: "Bienvenido de nuevo",
    register_title: "Crea tu cuenta Lumfi",
    no_account: "¿No tienes cuenta?",
    have_account: "¿Ya tienes cuenta?",
    step_of: "Paso {n} de 6",
    profile_setup: "Configurar perfil",
    onb_welcome_title: "Bienvenido a Lumfi",
    onb_welcome_sub: "Configuremos tu perfil para personalizar tu diagnóstico financiero.",
    full_name: "Nombre completo",
    professional_activity: "Actividad profesional",
    currency: "Moneda",
    avg_monthly_income: "Ingreso mensual promedio",
    money_title: "¿Dónde está tu dinero hoy?",
    money_sub: "Agrega efectivo, bancos y billeteras digitales.",
    receivables_title: "Cobros pendientes",
    receivables_sub: "Lo que te deben los clientes y cuándo.",
    payments_title: "Pagos próximos",
    payments_sub: "Cuentas y obligaciones por pagar.",
    withdrawal_title: "Retiro deseado",
    withdrawal_sub: "¿Cuánto quieres retirar esta semana?",
    desired_amount: "Monto deseado",
    reason: "Motivo",
    finish_calc: "Calcular dashboard",
    dashboard: "Panel",
    real_cash: "Caja real disponible",
    safe_to_use: "Seguro de usar esta semana",
    monthly_risk: "Riesgo mensual",
    recommended_action: "Acción recomendada",
    current_cash: "Caja actual",
    expected_receivables: "Cobros esperados",
    upcoming_payments: "Pagos próximos",
    suggested_reserve: "Reserva sugerida",
    desired_withdrawal: "Retiro deseado",
    last_updated: "Última actualización",
    of_real_cash: "de la caja real",
    financial_breakdown: "Desglose financiero",
    // Claridad de marco temporal (Inicio / Históricos / Reporte)
    dashboard_scope_badge: "Foto actual",
    dashboard_scope_sub: "Vista en vivo — refleja tu saldo, cobros y pagos en este momento.",
    history_scope_badge: "Actividad pasada",
    history_scope_sub: "Solo movimientos, cobros y pagos que ya ocurrieron en el mes seleccionado.",
    report_scope_badge_weekly: "Semana seleccionada",
    report_scope_badge_monthly: "Mes seleccionado",
    report_scope_sub: "Resumen del periodo de abajo, incluye pendientes con vencimiento dentro del rango.",
    report_subtitle: "Resumen del periodo",
    showing_period: "Mostrando",
    // Deriva por tipo de cambio
    fx_drift_title: "Deriva por tipo de cambio en el periodo",
    fx_drift_sub: "Valor ganado o perdido en ítems en moneda extranjera, únicamente por el movimiento del tipo de cambio desde que fueron registrados.",
    fx_drift_assets: "Deriva en cobros",
    fx_drift_liabilities: "Deriva en pagos",
    fx_drift_realized: "Deriva realizada",
    fx_drift_net: "Impacto neto por FX",
    fx_drift_recorded: "Valor registrado",
    fx_drift_current: "Valor actual",
    fx_drift_empty: "No hay ítems en moneda extranjera en este periodo, no hay nada que comparar contra la tasa de hoy.",
    fx_drift_pending_receivables: "Cobros pendientes",
    fx_drift_pending_payments: "Pagos pendientes",
    fx_drift_realized_section: "Ya liquidados",
    fx_drift_favourable: "Favorable",
    fx_drift_unfavourable: "Desfavorable",
    fx_drift_neutral: "Neutral",
    fx_resnapshot_btn: "Restablecer línea base de FX a hoy",
    fx_resnapshot_sub: "Recalcula todo ítem en moneda extranjera con la tasa de hoy. La deriva vuelve a cero.",
    fx_resnapshot_done: "Línea base recalculada",
    fx_resnapshot_confirm: "Esto reescribe el monto y el fx_rate de cada cobro, pago y movimiento que tengas en una moneda distinta a la del perfil. La deriva volverá a cero. ¿Continuar?",
    home: "Inicio",
    nav_add: "Asistente",
    nav_receivables: "Cobros",
    nav_payments: "Pagos",
    nav_history: "Movimientos",
    nav_report: "Reporte",
    logout: "Cerrar sesión",
    load_demo: "Cargar datos demo",
    clear_demo: "Borrar mis datos",
    quick_movement: "Movimiento Rápido",
    quick_movement_help: "Usa +/- y escribe naturalmente para registrar.",
    quick_placeholder: "+ 800000 Cliente Ana pagó diseño\n- 120000 internet",
    categorize_as: "Categorizar como",
    income: "Ingreso",
    expense: "Gasto",
    receivable: "Cobro",
    payment: "Pago",
    save_movement: "Guardar movimiento",
    amount: "Monto",
    description: "Descripción",
    new_receivable: "Nuevo cobro",
    client_name: "Nombre del cliente",
    expected_date: "Fecha esperada",
    probability: "Probabilidad",
    high: "Alta",
    medium: "Media",
    low: "Baja",
    pending: "Pendiente",
    collected: "Cobrado",
    mark_collected: "Marcar cobrado",
    new_payment: "Nuevo pago",
    concept: "Concepto",
    due_date: "Fecha límite",
    type: "Tipo",
    priority: "Prioridad",
    paid: "Pagado",
    mark_paid: "Marcar pagado",
    postpone: "Posponer",
    weekly_report: "Reporte Semanal",
    copy_summary: "Copiar resumen",
    pdf_downloaded: "PDF descargado",
    print: "Imprimir / PDF",
    copied: "Copiado al portapapeles",
    risk_low: "Bajo",
    risk_medium: "Medio",
    risk_high: "Alto",
    confirm_delete: "Confirmar eliminación",
    confirm_delete_recv: "¿Eliminar cobro de {name}? Esta acción no se puede deshacer.",
    confirm_delete_pay: "¿Eliminar pago {name}? Esta acción no se puede deshacer.",
    confirm_clear_data: "¿Borrar todos tus datos? Se eliminarán cuentas, cobros, pagos y movimientos.",
    language: "Idioma",
    action_do_not_withdraw: "No retires más de {safe_amount} esta semana.",
    action_collect_largest: "Cobra a {client_name} antes de hacer nuevos pagos.",
    action_prioritize_payments: "Prioriza los pagos próximos antes de gastos discrecionales.",
    action_safe_use: "Puedes usar de forma segura hasta {safe_amount} esta semana.",
    action_stay_cautious: "Mantente cauteloso. Seguro de usar esta semana: {safe_amount}.",
    wealth_overview: "Patrimonio",
    net_worth: "Patrimonio neto",
    investments: "Inversiones",
    debts: "Deudas",
    goals: "Metas",
    items: "ítems",
    recurring: "Periódico",
    frequency: "Frecuencia",
    end_date: "Fecha fin",
    weekly: "Semanal",
    biweekly: "Quincenal",
    monthly: "Mensual",
    quarterly: "Trimestral",
    yearly: "Anual",
  },
  pt: {
    app_name: "Lumfi Cash Pilot",
    continue: "Continuar",
    back: "Voltar",
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    edit: "Editar",
    add: "Adicionar",
    skip: "Pular",
    loading: "Carregando...",
    landing_badge: "Acesso Piloto",
    landing_title: "Saiba quanto dinheiro você pode usar esta semana sem ficar sem caixa.",
    landing_sub: "Para freelancers com renda variável, recebíveis pendentes e pagamentos próximos.",
    start_diagnosis: "Iniciar diagnóstico",
    sign_in: "Entrar",
    sign_up: "Criar conta",
    landing_eyebrow: "Para freelancers na América Latina",
    landing_hero_title_a: "Quanto posso gastar este mês",
    landing_hero_title_b: "sem estourar?",
    landing_hero_sub: "Lumfi é o piloto de fluxo de caixa para renda variável. Um número diz o que é seguro usar hoje — baseado em recebíveis, dívidas e pagamentos próximos.",
    landing_hero_cta: "Quero meu número seguro",
    landing_hero_secondary: "Ver como funciona",
    landing_hero_chip_1: "Sem cartão",
    landing_hero_chip_2: "Plano grátis pra sempre",
    landing_hero_chip_3: "Pronto em 4 minutos",
    landing_snap_label: "Seu caixa real hoje",
    landing_snap_safe: "Seguro pra usar esta semana",
    landing_snap_pending: "Recebíveis pendentes",
    landing_snap_risk: "Risco do mês · Médio",
    landing_snap_explain: "Inclui 2 recebíveis de clientes + 10% de reserva.",
    landing_trust_label: "Feito para renda variável em toda a LATAM",
    landing_problem_eyebrow: "A ansiedade do freelancer",
    landing_problem_h2: "Você não tem salário. Tem uma pergunta toda segunda.",
    landing_problem_q1: "Consigo pagar o aluguel e comprar o equipamento que preciso este mês?",
    landing_problem_q2: "Esse dinheiro já está prometido em impostos, ou é meu?",
    landing_problem_q3: "Se o cliente atrasar de novo, estou em apuros?",
    landing_problem_h2b: "Lumfi responde as três. Todo dia.",
    landing_problem_p: "Outras ferramentas registram o que já passou. Lumfi pilota o que vem — pra você parar de chutar e seguir com confiança.",
    landing_steps_eyebrow: "Como funciona",
    landing_steps_h2: "Quatro minutos até seu primeiro diagnóstico",
    landing_step_1_t: "Conta o que é real",
    landing_step_1_d: "Caixa que você tem, clientes que devem, contas que vêm, dívidas em curso. Sem ligar o banco, sem importar planilhas.",
    landing_step_2_t: "A gente faz as contas",
    landing_step_2_d: "Recebíveis × probabilidade − pagamentos fixos − reserva = seu número seguro. Atualizado ao vivo.",
    landing_step_3_t: "Voe com copiloto",
    landing_step_3_d: "Registre por chat (web, Telegram, WhatsApp). O piloto recalcula e avisa se a rota muda.",
    landing_features_eyebrow: "O que você ganha",
    landing_features_h2: "Tudo que um CFO faria pra você. Sem o CFO.",
    landing_feat_cash_t: "Caixa real, hoje",
    landing_feat_cash_d: "Não é saldo do banco. É o dinheiro que é seu depois de dívidas, impostos e compromissos.",
    landing_feat_risk_t: "Semáforo de risco mensal",
    landing_feat_risk_d: "Verde / Amarelo / Vermelho. Bate o olho e já sabe se o mês vai apertar.",
    landing_feat_ai_t: "Chat com IA pra registrar",
    landing_feat_ai_d: "\"Paguei Netflix 39\" e o piloto atualiza tudo. Funciona no Telegram, WhatsApp e web.",
    landing_feat_rec_t: "Recebíveis e pagamentos",
    landing_feat_rec_d: "Quem te deve, quem você deve. Recorrentes ou únicos, em qualquer moeda.",
    landing_feat_wealth_t: "Módulos de patrimônio",
    landing_feat_wealth_d: "Investimentos, dívidas e metas — todos ponderados no seu número seguro.",
    landing_feat_fx_t: "Multi-moeda nativo",
    landing_feat_fx_d: "ARS, BRL, CLP, COP, MXN, PEN, UYU. Cotações aplicadas pra te dar um número honesto.",
    landing_bots_eyebrow: "Pilote seu dinheiro de onde estiver",
    landing_bots_h2: "Telegram. WhatsApp. Web. Você decide.",
    landing_bots_p: "Três segundos pra registrar uma despesa. Dois pra perguntar \"posso gastar isso?\". Lumfi responde no canal onde você já mora.",
    landing_pricing_eyebrow: "Preços",
    landing_pricing_h2: "Seu saldo não é seu dinheiro disponível. A Lumfi te diz quanto pode usar sem quebrar o mês.",
    landing_pricing_free_t: "Control",
    landing_pricing_free_d: "Caixa real + semáforo + recebíveis. Grátis pra sempre.",
    landing_pricing_pilot_t: "Pilot",
    landing_pricing_pilot_d: "Adiciona copiloto IA no chat, previsões avançadas e rollovers recorrentes.",
    landing_pricing_negocio_t: "Negocio",
    landing_pricing_negocio_d: "Times, moedas customizadas, suporte prioritário e exports white-label.",
    landing_pricing_cta: "Ver preços completos",
    landing_pricing_popular: "Mais escolhido",
    landing_faq_eyebrow: "FAQ",
    landing_faq_h2: "Perguntas que freelancers realmente fazem",
    landing_faq_q1: "Preciso conectar meu banco?",
    landing_faq_a1: "Não. Lumfi trabalha com o que você conta. Você tem controle total do que é registrado.",
    landing_faq_q2: "Faturo em USD mas moro no Brasil. Funciona?",
    landing_faq_a2: "Sim. Lumfi é multi-moeda em todos os níveis: por movimento, recebível, dívida. Aplicamos cotações diárias pra te dar um número único e honesto.",
    landing_faq_q3: "Meus dados são privados?",
    landing_faq_a3: "Seus números não saem da sua conta. Não vendemos nem compartilhamos dados financeiros, e você pode apagar tudo com um clique.",
    landing_faq_q4: "E se um cliente atrasar?",
    landing_faq_a4: "O semáforo reage na hora. Você vê a nova cor do mês e o Lumfi sugere onde cortar pra continuar voando.",
    landing_faq_q5: "Posso usar com sócios ou time?",
    landing_faq_a5: "O plano Negocio suporta workspaces compartilhados, papéis por usuário e auditoria.",
    landing_final_eyebrow: "Pare de chutar",
    landing_final_h2: "Descubra seu número real em 4 minutos.",
    landing_final_p: "Grátis pra sempre o essencial. Sem cartão. Sem compromisso. Só clareza.",
    landing_final_cta: "Começar — é grátis",
    landing_footer_tag: "O piloto de fluxo de caixa pra freelancers.",
    landing_footer_product: "Produto",
    landing_footer_company: "Empresa",
    landing_footer_legal: "Legal",
    landing_footer_pricing: "Preços",
    landing_footer_features: "Funcionalidades",
    landing_footer_about: "Sobre o Lumfi",
    landing_footer_privacy: "Privacidade",
    landing_footer_terms: "Termos",
    landing_footer_rights: "Todos os direitos reservados",
    email: "E-mail",
    password: "Senha",
    login_title: "Bem-vindo de volta",
    register_title: "Crie sua conta Lumfi",
    no_account: "Ainda não tem conta?",
    have_account: "Já tem conta?",
    step_of: "Passo {n} de 6",
    profile_setup: "Configurar perfil",
    onb_welcome_title: "Bem-vindo ao Lumfi",
    onb_welcome_sub: "Vamos configurar seu perfil para personalizar seu diagnóstico financeiro.",
    full_name: "Nome completo",
    professional_activity: "Atividade profissional",
    currency: "Moeda",
    avg_monthly_income: "Renda mensal média",
    money_title: "Onde está seu dinheiro hoje?",
    money_sub: "Adicione saldos em dinheiro, bancos e carteiras digitais.",
    receivables_title: "Recebíveis pendentes",
    receivables_sub: "O que os clientes devem e quando.",
    payments_title: "Pagamentos próximos",
    payments_sub: "Contas e obrigações a pagar.",
    withdrawal_title: "Saque desejado",
    withdrawal_sub: "Quanto você quer usar esta semana?",
    desired_amount: "Valor desejado",
    reason: "Motivo",
    finish_calc: "Calcular painel",
    dashboard: "Painel",
    real_cash: "Caixa real disponível",
    safe_to_use: "Seguro para usar esta semana",
    monthly_risk: "Risco mensal",
    recommended_action: "Ação recomendada",
    current_cash: "Caixa atual",
    expected_receivables: "Recebíveis esperados",
    upcoming_payments: "Pagamentos próximos",
    suggested_reserve: "Reserva sugerida",
    desired_withdrawal: "Saque desejado",
    last_updated: "Última atualização",
    of_real_cash: "do caixa real",
    financial_breakdown: "Detalhamento financeiro",
    dashboard_scope_badge: "Foto atual",
    dashboard_scope_sub: "Visualização ao vivo — reflete seu saldo, recebíveis e pagamentos neste momento.",
    history_scope_badge: "Atividade passada",
    history_scope_sub: "Apenas movimentos, recebíveis e pagamentos que já ocorreram no mês selecionado.",
    report_scope_badge_weekly: "Semana selecionada",
    report_scope_badge_monthly: "Mês selecionado",
    report_scope_sub: "Resumo do período abaixo, incluindo itens pendentes com vencimento dentro do intervalo.",
    report_subtitle: "Resumo do período",
    showing_period: "Mostrando",
    fx_drift_title: "Variação cambial no período",
    fx_drift_sub: "Valor ganho ou perdido em itens em moeda estrangeira, apenas pelo movimento do câmbio desde o registro.",
    fx_drift_assets: "Variação em recebíveis",
    fx_drift_liabilities: "Variação em pagamentos",
    fx_drift_realized: "Variação realizada",
    fx_drift_net: "Impacto cambial líquido",
    fx_drift_recorded: "Valor registrado",
    fx_drift_current: "Valor atual",
    fx_drift_empty: "Não há itens em moeda estrangeira neste período.",
    fx_drift_pending_receivables: "Recebíveis pendentes",
    fx_drift_pending_payments: "Pagamentos pendentes",
    fx_drift_realized_section: "Já liquidados",
    fx_drift_favourable: "Favorável",
    fx_drift_unfavourable: "Desfavorável",
    fx_drift_neutral: "Neutro",
    fx_resnapshot_btn: "Redefinir linha base de câmbio para hoje",
    fx_resnapshot_sub: "Recalcula cada item em moeda estrangeira com a taxa de hoje. A variação volta a zero.",
    fx_resnapshot_done: "Linha base recalculada",
    fx_resnapshot_confirm: "Isso reescreve o valor e a taxa de câmbio de cada recebível, pagamento e movimento em moeda diferente do perfil. Continuar?",
    home: "Início",
    nav_add: "Assistente",
    nav_receivables: "Recebíveis",
    nav_payments: "Pagamentos",
    nav_history: "Movimentos",
    nav_report: "Relatório",
    logout: "Sair",
    load_demo: "Carregar dados de demonstração",
    clear_demo: "Limpar meus dados",
    quick_movement: "Movimento rápido",
    quick_movement_help: "Use +/- e digite naturalmente para registrar.",
    quick_placeholder: "+ 800000 Cliente Ana pagou design\n- 120000 conta de internet",
    categorize_as: "Categorizar como",
    income: "Receita",
    expense: "Despesa",
    receivable: "Recebível",
    payment: "Pagamento",
    save_movement: "Salvar movimento",
    amount: "Valor",
    description: "Descrição",
    new_receivable: "Novo recebível",
    client_name: "Nome do cliente",
    expected_date: "Data esperada",
    probability: "Probabilidade",
    high: "Alta",
    medium: "Média",
    low: "Baixa",
    pending: "Pendente",
    collected: "Recebido",
    mark_collected: "Marcar como recebido",
    new_payment: "Novo pagamento",
    concept: "Conceito",
    due_date: "Data de vencimento",
    type: "Tipo",
    priority: "Prioridade",
    paid: "Pago",
    mark_paid: "Marcar como pago",
    postpone: "Adiar",
    weekly_report: "Relatório semanal",
    copy_summary: "Copiar resumo",
    pdf_downloaded: "PDF baixado",
    print: "Imprimir / PDF",
    copied: "Copiado para a área de transferência",
    risk_low: "Baixo",
    risk_medium: "Médio",
    risk_high: "Alto",
    confirm_delete: "Confirmar exclusão",
    confirm_delete_recv: "Excluir recebível de {name}? Isso não pode ser desfeito.",
    confirm_delete_pay: "Excluir pagamento {name}? Isso não pode ser desfeito.",
    confirm_clear_data: "Excluir todos os seus dados? Isso removerá contas, recebíveis, pagamentos e movimentos.",
    language: "Idioma",
    action_do_not_withdraw: "Não saque mais de {safe_amount} esta semana.",
    action_collect_largest: "Receba de {client_name} antes de fazer novos pagamentos.",
    action_prioritize_payments: "Priorize pagamentos próximos antes de gastos discricionários.",
    action_safe_use: "Você pode usar com segurança até {safe_amount} esta semana.",
    action_stay_cautious: "Mantenha cautela. Seguro para usar esta semana: {safe_amount}.",
    wealth_overview: "Patrimônio",
    net_worth: "Patrimônio líquido",
    investments: "Investimentos",
    debts: "Dívidas",
    goals: "Metas",
    items: "itens",
    recurring: "Recorrente",
    frequency: "Frequência",
    end_date: "Data final",
    weekly: "Semanal",
    biweekly: "Quinzenal",
    monthly: "Mensal",
    quarterly: "Trimestral",
    yearly: "Anual",
  },
};

export function t(lang, key, vars = {}) {
  const value = (dict[lang] && dict[lang][key]) || dict.en[key] || key;
  return Object.keys(vars).reduce((s, k) => s.replace(`{${k}}`, vars[k]), value);
}

/** 3-tuple translator — pass the literal strings directly without
 *  needing a key in the dict. Cleaner than nested ternaries for the
 *  hundreds of one-off strings scattered across legacy components.
 *
 *  Usage: tx(lang, "Hello", "Hola", "Olá")
 *  Order: (lang, en, es, pt). PT falls back to ES if not provided.
 */
export function tx(lang, en, es, pt) {
  if (lang === "pt") return pt ?? es ?? en;
  if (lang === "es") return es ?? en;
  return en;
}

export function translateAction(lang, code, params, fallback, formatMoney, currency) {
  if (!code) return fallback;
  const key = `action_${code}`;
  const formattedParams = { ...params };
  if (params && "safe_amount" in params && formatMoney) {
    formattedParams.safe_amount = formatMoney(params.safe_amount, currency);
  }
  return t(lang, key, formattedParams);
}
